module.exports = __webpack_public_path__ + "static/media/bizzsurfer.d183a94c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bizzsurfer.webp
// module id = 236
// module chunks = 0